// extracted by css-extract-rspack-plugin
module.exports =  {"root":"aeebb043d9","petsshopText":"b1e72d0b87"};